import React, { useEffect, useState } from "react";
import { getAllCategories } from "../../lib/sanity/data";
import { Category } from "../../lib/sanity";
import BlogPageClient from "../../components/blog/BlogPageClient";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPosts,
  selectPosts,
  selectPostsLoading,
} from "../../store/postsSlice";
import { AppDispatch } from "../../store/store";
import SEO from "../../components/seo/SEO";

const BlogPage: React.FC = () => {
  const posts = useSelector(selectPosts);
  const postsLoading = useSelector(selectPostsLoading);
  const [categories, setCategories] = useState<Category[]>([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        setCategoriesLoading(true);
        const cats = await getAllCategories();
        setCategories(cats);
      } catch (err) {
        console.error("Failed to load categories:", err);
      } finally {
        setCategoriesLoading(false);
      }
    };
    loadCategories();
  }, []);

  const loading = postsLoading || categoriesLoading;

  return (
    <>
      <SEO
        title="Blog"
        description="Stay updated with the latest insights from MeetMyBot. Explore articles about AI, chatbots, digital transformation, and product updates that help your business grow smarter."
        keywords={['blog', 'ai', 'chatbots', 'insights', 'digital transformation', 'product updates']}
      />
      <Header />
      <BlogPageClient
        initialPosts={posts}
        initialCategories={categories}
        loading={loading}
      />
      <Footer />
    </>
  );
};

export default BlogPage;
